<template>
    <div class="content-wrapper">
        <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-8">
                        <h1 class="m-0">Apply for a Loan</h1>
                    </div>
                    <div class="col-sm-4">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/apply-loan">
                                    <p>Apply for a Loan</p>
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active">
                                {{breadcrumb}}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <!-- main content -->
        <div class="container-fluid">

            <Steps :formIndicator="loan_process" :currentStep="loan_process.step" v-if="loan_process.step" />

            <div class="row justify-content-center" id="err0">
                <div class="col-md-12 col-sm-12" :class="loan_process.progress=='S2Q3'? 'col-lg-11' : 'col-lg-10'">
                    <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="error">
                        <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=0">&times;</button>
                        <a target="#err0" hidden id="err"></a>
                        <div class="alert-body">
                            <p v-if="error_message && errors.length == 0" class="mb-0">
                                {{ error_message }}
                            </p>
                            <div v-for="(v, k) in errors" :key="k">
                                <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <S1Q1 :formLoan="formLoan" @next="submitStep(1,'S1Q2')" @back="backStep" @error="onError" @load="onLoad" v-if="loan_process.step==1 && loan_process.progress=='S1Q1' && formArr.length" />
            <S1Q2 :formLoan="formLoan" @next="submitStep(2,'S2Q1')" @back="backStep(1,'S1Q1')" @error="onError" @load="onLoad" v-if="loan_process.step==1 && loan_process.progress=='S1Q2' && formArr.length" />
            <S2Q1 :formLoan="formLoan" @next="submitStep(2,'S2Q1A')" @back="backStep(1,'S1Q2')" @error="onError" @load="onLoad" v-if="loan_process.step==2 && loan_process.progress=='S2Q1' && formArr.length" :user="user" />
            <S2Q1A :app_id="formLoan.application_id" @next="submitStep(2,'S2Q2')" @back="backStep(2,'S2Q1')" @error="onError" @load="onLoad" v-if="loan_process.step==2 && loan_process.progress=='S2Q1A' && formArr.length" />

            <S2Q2 :formLoan="formLoan" @next="submitStep(2,['S2Q3','S2Q4'])" @back="backStep(2,'S2Q1A')" @error="onError" @load="onLoad" v-if="loan_process.step==2 && loan_process.progress=='S2Q2' && formArr.length" :user="user" />
            <S2Q3 :app_id="formLoan.application_id" :bor_id="formLoan.borrower_id" @next="submitStep(2,'S2Q4')" @back="backStep(2,'S2Q2')" @error="onError" @load="onLoad" v-if="loan_process.step==2 && loan_process.progress=='S2Q3' && formArr.length" />
            <S2Q4 :app_id="formLoan.application_id" @next="submitStep(3,'S3Q1')" @back="backStep(2,['S2Q3','S2Q2'])" @error="onError" @load="onLoad" v-if="loan_process.step==2 && loan_process.progress=='S2Q4' && formArr.length" />
            <S3Q1 :formLoan="formLoan" @next="submitStep(3,'S3Q2')" @back="backStep(2,['S2Q3','S2Q4'])" @error="onError" @load="onLoad" v-if="loan_process.step==3 && loan_process.progress=='S3Q1' && formArr.length" />
            <S3Q2 :formLoan="formLoan" :user="user" @next="submitStep(4,'S4Q1')" @back="backStep(3,'S3Q1')" @error="onError" @load="onLoad" v-if="loan_process.step==3 && loan_process.progress=='S3Q2' && formArr.length" />
            <S4Q1 :formLoan="formLoan" :user="user" @next="submitStep(4, 'S4Q2')" @back="backStep(3,'S3Q2')" @reset="backStep(3,'S3Q1')" @error="onError" @load="onLoad" v-if="loan_process.step==4 && loan_process.progress=='S4Q1' && formArr.length" />
            <S4Q2 :formLoan="formLoan" :user="user" @next="submitStep(4,'S4Q3')" @back="backStep(4,'S4Q1')" @error="onError" @load="onLoad" v-if="loan_process.step==4 && loan_process.progress=='S4Q2' && formArr.length" />
            <S4Q3 :formLoan="formLoan" :user="user" @next="submitStep(5, 'S5Q1')" @back="backStep(4,'S4Q2')" @error="onError" @load="onLoad" v-if="loan_process.step==4 && loan_process.progress=='S4Q3' && formArr.length" />
            <S5Q1 :formLoan="formLoan" @error="onError" @load="onLoad" @back="backStep(4,'S4Q3')" v-if="loan_process.step==5 && loan_process.progress=='S5Q1' && formArr.length" />
        </div>
        <!-- /main content -->
    </div>
</template>
<script>
    import Steps from "@loan/section/Steps.vue";

    import S1Q1 from "@loan/SBLAF/forms/S1-Q1.vue";
    import S1Q2 from "@loan/SBLAF/forms/S1-Q2.vue";
    import S2Q1 from "@loan/SBLAF/Financing/modified/S2-Q1.vue";
    // import S2Q1 from "@loan/SBLAF/forms/S2-Q1.vue";
    import S2Q1A from "@loan/SBLAF/forms/S2-Q1A.vue";
    import S2Q2 from "@loan/SBLAF/Financing/modified/S2-Q2.vue";



    import S2Q3 from "@loan/SBLAF/forms/S2-Q3.vue";
    import S2Q4 from "@loan/SBLAF/forms/S2-Q4.vue";

    import S3Q1 from "@loan/SBLAF/Financing/modified/S3-Q1.vue";
    import S3Q2 from "@loan/SBLAF/forms/S3-Q2.vue";
    import S4Q1 from "@loan/SBLAF/forms/S4-Q1.vue";
    import S4Q2 from "@loan/SBLAF/forms/S4-Q2.vue";
    import S4Q3 from "@loan/SBLAF/forms/S4-Q3.vue";
    import S5Q1 from "@loan/SBLAF/forms/S5-Q1.vue";

    //built-in jsons
    import loan_cat from "@json/loan_cat.json";

    // api
    import {
        apiGetInitialize,
        apiGetLoanReq,
        apiUpdateLoanReq,
        apiUpdateLoanStep
    } from "@js/api/applyLoanApi";



    export default {
        beforeRouteEnter(to, from, next) {
            if (from.path === "/apply-loan") {
                next();
            } else {
                next({
                    path: "/apply-loan",
                });
            }
        },
        components: {
            S1Q1,
            S1Q2,
            S2Q1,
            S2Q1A,
            S2Q2,
            S2Q3,
            S2Q4,
            S3Q1,
            S3Q2,
            S4Q1,
            S4Q2,
            S4Q3,
            S5Q1,
            Steps,
        },

        data() {
            return {
                error: false,
                errors: [],
                error_message: '',

                user: {},
                loan_process: {},
                loading: false,
                loan_cat: loan_cat,
                erf: '',
                formArr: [],
                formLoan: {
                    borrower_id: null,
                    application_id: null,
                    filipino: null,
                    bus_year: null,
                    bt_code: null,
                    loan_cat: null,
                    bus_id: null,
                    business_name: null,
                    start_date: null,
                    s_start_date: null,
                    province_code: null,
                    city_code: null,
                    bcode: null,
                    bldg: null,
                    street_address: null,
                    areacode: null,
                    asset_size: null,
                    annual_sale: null,
                    tin: null,
                    prev_reg_emp: null,
                    prev_contract_emp: null,
                    current_reg: null,
                    current_contract: null,

                    req_loan_amt: null,
                    req_loan_term: null,
                    grace_period: null,
                    service_fee: null,
                    install_fee: null,
                    monthly: null,

                    manner_rel: null,
                    bankname: null,
                    acctname: null,

                    bus_reg_city: null,
                    bus_reg_province: null,
                    bus_reg_date: null,
                    bus_reg_cityname: null,
                    bus_reg_provincename: null,

                    acctno: null,
                    inhouse_fs: null,
                    nbuss_code: null,
                    bir: null,
                    permit2019: null,
                    current_permit: null,
                    odette_damage: null,
                    track: null,

                    province: null,
                    city: null,
                    bname: null,
                    max_loan: null,
                    manner_rel_desc: null,
                    loan_bus_code: null,
                    prev_bank: null,

                    loan_purpose_code: null,
                    loan_purpose_other: null,
                    interest_rate_pa: null,
                    existing_borrower: null,

                    num_subsidiary: null,
                    buss_activity: null,
                    social_media: null,
                    industry: null,
                    add_ship: null,
                    num_branches: null,

                    annual_sales: null,
                    owners_monthly_income: null,
                    num_cars_owned: null,
                    philsys: null,
                    firm_class_id: null,
                    repayment_mode: null,
                },
                loader: 0,

                business_info: [],
            };
        },

        created() {
            this.initData();
            // Fire.$on("getLoanReq", () => {
            //     this.formArr = [];
            //     this.getLoanReq(this.formLoan.application_id);
            // });
            // Fire.$on("getLoanReqATT", () => {
            //     this.getLoanReq(this.formLoan.application_id);
            // });
        },
        methods: {
            getProgramERF(app_id) {
                this.loader++;
                axios.get('/api/sblaf-erf-program', {
                    params: {
                        application_id: app_id
                    },
                }).then(res => {
                    this.loader--;
                    this.erf = ' - ' + res.data;
                }).catch(err => {
                    this.loader--;
                })
            },
            onLoad(x) {
                this.loader += x;
            },
            resetError() {
                this.errors = [];
                this.error_message = '';
                this.error = 0;
            },
            onError(error) {
                this.error = 1;
                if (error.response && error.response.data) {
                    if (error.response.status && error.response.status >= 500) {
                        this.error_message = 'Transaction Failed';
                    } else {
                        this.errors = error.response.data.errors || [];
                        this.error_message = error.response.data.message;
                    }
                } else {
                    // this.error_message = error.message
                    this.error_message = 'Transaction Failed'
                }
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            async apiSubmitStep(s, p) {
                const step = {
                    application_id: this.formLoan.application_id,
                    step: s,
                    progress: p
                }
                try {
                    this.loader++;
                    const res = await apiUpdateLoanStep(step);
                    this.loan_process = res.loan_process;
                } catch (error) {
                    this.onError(error);
                    console.error('Error:', error);
                } finally {
                    this.loader--;
                }
            },
            submitStep(s, p) {
                this.resetError();
                if (_.isArray(p)) {
                    //p = ['S2Q3,S2Q4']
                    if (s == 2) {
                        if (this.formLoan.bt_code != 'BT2020001') {
                            this.apiSubmitStep(s, p[0])
                        } else {
                            this.apiSubmitStep(s, p[1])
                        }
                    } else {
                        this.apiSubmitStep(s, p)
                    }
                } else {
                    this.apiSubmitStep(s, p)
                }
            },
            backStep(s, p) {
                this.resetError();
                if (_.isArray(p)) {
                    //p = ['S2Q3,S2Q4']
                    if (s == 2) {
                        if (this.formLoan.bt_code != 'BT2020001') {
                            this.apiSubmitStep(s, p[0])
                        } else {
                            this.apiSubmitStep(s, p[1])
                        }
                    } else {
                        this.apiSubmitStep(s, p)
                    }
                } else {
                    this.apiSubmitStep(s, p)
                }
            },



            async initData() {
                this.loader++;
                try {
                    const data = await apiGetInitialize();

                    this.user = data.user;
                    this.loan_process = data.loan_process;

                    const data2 = await apiGetLoanReq(data.loan_process.application_id);

                    this.formArr = [data2.loan_req];
                    // this.formLoan = this.$setDataObj(this.formLoan, data2.loan_req);
                    this.formLoan = _.assign(this.formLoan, data2.loan_req);

                    // this.getProgramERF(data.loan_process.application_id);
                } catch (error) {
                    this.onError(error);
                } finally {
                    this.loader--;
                }
            },

        },
        computed: {
            breadcrumb() {
                const title = {
                    'FIB18': 'Startup',
                    'FIB19': 'Franchising',
                    'FIB20': 'PO-Financing'
                };
               return title[this.formLoan.loan_bus_code] || '';
            },
            processingAPI() {
                return this.loader > 0;
            },
            name_borrower() {
                let name = "";
                if (this.user) {
                    if (this.user.suffix_desc) {
                        name =
                            this.user.fname +
                            " " +
                            this.user.mname +
                            " " +
                            this.user.lname +
                            " " +
                            this.user.suffix_desc;
                    } else {
                        name =
                            this.user.fname +
                            " " +
                            this.user.mname +
                            " " +
                            this.user.lname;
                    }
                }
                return name;
            },
        },
        mounted() {

        },
    };
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }
</style>